import ValidationInterface from '@/plans/common/validation-interface';
import {
  eventsUnlimitedCategory,
  eventsPPACategory,
  sessionsUnlimitedCategory,
  sessionsPPACategory,
} from '@/common/persist-cart/categories';
import { EVENT_SAAS_ADDITIONAL_HOST, EVENT_SAAS_CORE_ADDITIONAL_HOST } from '@/common/constants';

export default class extends ValidationInterface {
  async requires() {
    return [
      this.current([EVENT_SAAS_ADDITIONAL_HOST]).require([
        ...eventsUnlimitedCategory,
        ...eventsPPACategory
      ]),
      this.current([EVENT_SAAS_CORE_ADDITIONAL_HOST]).require([
        ...sessionsUnlimitedCategory,
        ...sessionsPPACategory,
      ]),
    ];
  }

  async conflicts() {
    return [
      ...this.current([EVENT_SAAS_ADDITIONAL_HOST]).conflict(EVENT_SAAS_ADDITIONAL_HOST),
      ...this.current([EVENT_SAAS_CORE_ADDITIONAL_HOST]).conflict(EVENT_SAAS_CORE_ADDITIONAL_HOST),
    ];
  }
}
